import * as React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { State } from '../../../../common/interfaces/state';
import { getOrCreateRoot } from '../utils';


interface StateProps {
  open: boolean;
}

interface OwnProps {
  name: string;
  onClose?: () => void;
  dialogAnimationDelay?: number;
}

interface Props extends StateProps, OwnProps {
}

export class DialogWrapperComponent extends React.PureComponent<Props> {
  public static root: HTMLDivElement;

  constructor(props: Props) {
    super(props);
    DialogWrapperComponent.getRoot();
  }

  public static getRoot(): HTMLDivElement {
    if (!DialogWrapperComponent.root) {
      DialogWrapperComponent.root = getOrCreateRoot();
    }
    return DialogWrapperComponent.root;
  }

  public render(): React.ReactNode {
    if (!this.props.open) {
      return null;
    }
    return ReactDOM.createPortal(
      this.props.children,
      DialogWrapperComponent.root,
    );
  }
}


const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
  return {
    open: ownProps.name in state.dialog,
  };
};

const connecter = connect(mapStateToProps);
export const DialogWrapper = connecter(DialogWrapperComponent);
